export default __webpack_public_path__ + "static/media/capex-thop-medium.fc19412b.png";